import React from "react";
import cx from "classnames";
import { DropTarget, DragSource } from "react-dnd";
import "styles/drag-drop.css";

const createDropTarget = ({ dropType, dropResponse }) => Component => {
    const DropSpec = {
        canDrop: (props, monitor) =>
            monitor.getItemType().toString() === dropType.toString() &&
            (!props.canDrop || props.canDrop()),
        drop: props => dropResponse(props)
    };
    const DropCollector = (connect, monitor) => ({
        dropRef: connect.dropTarget(),
        isOver: monitor.isOver(),
        canDrop: monitor.canDrop()
    });

    return DropTarget(dropType, DropSpec, DropCollector)(
        ({ dropRef, isOver, ...restProps }) => (
            <div
                ref={dropRef}
                className={cx("drop-overlay", {
                    "light-box-shade  drop-overlay-visible": isOver
                })}
            >
                <Component {...restProps} isOver={isOver} />
            </div>
        )
    );
};

const createDragSource = ({
    dragType,
    canDrag,
    dragResponse,
    dropResult
}) => Component => {
    const DragSpec = {
        canDrag,
        beginDrag: dragResponse,
        endDrag: (props, monitor) => {
            if (monitor.didDrop()) {
                dropResult(props, monitor.getDropResult());
            }
        }
    };

    const DragCollector = connect => ({
        dragRef: connect.dragSource
    });

    return DragSource(dragType, DragSpec, DragCollector)(
        ({ dragRef, ...restProps }) => (
            <div ref={dragRef()}>
                <Component {...restProps} />
            </div>
        )
    );
};

export { createDragSource, createDropTarget };
